import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppFlexModule } from '../flex/index.js';
import { IconModule } from '../icons/index.js';
import { ButtonListComponent } from './button-list.component.js';
import { ButtonComponent } from './button.component.js';
import { TooltipModule } from '../tooltip/tooltip.module.js';
import { ConfirmModule } from '../confirm/confirm.module.js';
import { LargeButtonComponent } from './large-button.component.js';
import { BrowserModule } from '@angular/platform-browser';
import { LinkModule } from '../link/link.module.js';
import { TypographyModule } from 'lib/typography/index.js';

@NgModule({
	imports: [
		TypographyModule,
		CommonModule,
		BrowserModule,
		RouterModule,
		IconModule,
		AppFlexModule,
		TooltipModule,
		ConfirmModule,
		LinkModule
	],
	declarations: [ButtonComponent, ButtonListComponent, LargeButtonComponent],
	exports: [ButtonComponent, ButtonListComponent, LargeButtonComponent]
})
export class ButtonModule {}
